import { getCookieValue } from '../../src/javascript/cookie-utils.js';

(function($) {
	/*
	 * Define Variables
	 */
	let shop_modal = document.getElementById('js-shop-select-modal');

	let modal_button = document.getElementsByClassName('js-shop-modal-button');
	let modal_close_button = document.getElementById('js-shop-modal-close');
	let modal_link_button = document.getElementById('js-shop-modal-link');

	let region_select = document.getElementById('js-region-select');
	let country_select = document.getElementById('js-country-select');

	let hidden_countries = [];

	/*
	 * Modal open/close functionality
	 */

	function openShopSelectModal(event) {
		shop_modal.classList.toggle('active', true);
		document.body.classList.toggle('modal-toggled', true);
	}

	function closeShopSelectModal(event) {
		shop_modal.classList.toggle('active', false);
		document.body.classList.toggle('modal-toggled', false);
	}

	function toggleShopSelectModal(event) {
		shop_modal.classList.toggle('active');
		document.body.classList.toggle('modal-toggled');
	}

	for(let i = 0; i < modal_button.length; i++) {
		modal_button[i].addEventListener('click', toggleShopSelectModal, false);
	}

	modal_close_button.addEventListener('click', closeShopSelectModal);

	/*
	 * Region select functionality
	 */

	function showCountriesByRegion(region_id) {
		let countries = country_select.getElementsByClassName('country-option');

		// Add all hidden countries back into the country dropdown.
		for (let i = 0, count = hidden_countries.length; i < count; i++) {
			country_select.appendChild(hidden_countries[i]);
		}

		// Reset the hidden countries array.
		hidden_countries = [];

		// Generate a new list of countries to remove.
		for (let i = 0, count = countries.length; i < count; i++) {
			if (countries[i].dataset.region !== region_id) {
				hidden_countries.push(countries[i]);
			}
		}

		// Remove countries (and store for later use).
		for (let i = 0, count = hidden_countries.length; i < count; i++) {
			country_select.removeChild(hidden_countries[i]);
		}
	}

	region_select.addEventListener('change', function(event) {
		let target = event.target;
		let selected_region_id =
			target.options[target.selectedIndex].dataset.region;

		// Reset the country (if there's one selected already)
		country_select.selectedIndex = '0';
		country_select.disabled = false;

		// Disable the button as the country has been reset
		modal_link_button.disabled = true;

		showCountriesByRegion(selected_region_id);
	});

	/*
	 * Country select functionality
	 */

	country_select.addEventListener('change', function(event) {
		modal_link_button.disabled = false;
	});

	modal_link_button.addEventListener('click', function(event) {
		let shop_link_href =
			country_select.options[country_select.selectedIndex].dataset.href;

		window.location.href = shop_link_href;
	});

	/*
	* Onload functionality
	*/
	window.onload = function() {
		let country_cookie = getCookieValue('lindy_country').toUpperCase();

		// Search for an option for the detected country
		let detected_country_option = country_select.querySelector(
			"[data-country='" + country_cookie + "']"
		);

		// Enable and select elements if there's a detected country option
		if (null !== detected_country_option) {
			// Find the option for the detected region
			let detected_region_option = region_select.querySelector(
				"[data-region='" + detected_country_option.dataset.region + "']"
			);

			// Select detected region option
			detected_region_option.selected = true;

			// Enable country select
			country_select.disabled = false;

			// Show relevant countries from the detected region
			showCountriesByRegion(detected_country_option.dataset.region);

			// Select detected country option
			detected_country_option.selected = true;

			// Enable button to link to shop
			modal_link_button.disabled = false;
		}
	};
})(jQuery);
